import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CaretLeft, CaretRight, CalendarBlank } from "@phosphor-icons/react";

const COLORS = { blue: "#4dabf5", green: "#00e676", red: "#ff3b30", yellow: "#ffea00", purple: "#a970ff", orange: "#ff9100" };
const monthLabel = (ym) => new Date(`${ym}-01`).toLocaleDateString("ru-RU", { month: "long", year: "numeric" });

export default function MiniCalendar() {
  const nav = useNavigate();
  const today = new Date().toISOString().slice(0, 10);
  const [month, setMonth] = useState(today.slice(0, 7));
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get(`/events?month=${month}`).then((r) => setEvents(r.data)).catch(() => {});
  }, [month]);

  const shift = (d) => {
    const [y, m] = month.split("-").map(Number);
    const nd = new Date(y, m - 1 + d, 1);
    setMonth(`${nd.getFullYear()}-${String(nd.getMonth() + 1).padStart(2, "0")}`);
  };

  const [y, m] = month.split("-").map(Number);
  const first = new Date(y, m - 1, 1);
  const daysIn = new Date(y, m, 0).getDate();
  const offset = (first.getDay() + 6) % 7;
  const byDate = {};
  events.forEach((e) => { (byDate[e.date] = byDate[e.date] || []).push(e); });

  return (
    <div className="glass-card p-5" data-testid="mini-calendar">
      <div className="flex items-center gap-2 mb-3">
        <CalendarBlank size={18} weight="duotone" className="text-primary" />
        <h2 className="font-heading font-semibold text-sm capitalize flex-1">{monthLabel(month)}</h2>
        <button onClick={() => shift(-1)} data-testid="mini-cal-prev" className="p-1 rounded hover:bg-secondary transition-colors"><CaretLeft size={14} /></button>
        <button onClick={() => shift(1)} data-testid="mini-cal-next" className="p-1 rounded hover:bg-secondary transition-colors"><CaretRight size={14} /></button>
      </div>
      <div className="grid grid-cols-7 gap-0.5 text-center text-[10px] text-muted-foreground mb-1">
        {["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"].map((d) => <div key={d}>{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-0.5">
        {Array.from({ length: offset }).map((_, i) => <div key={`e${i}`} />)}
        {Array.from({ length: daysIn }).map((_, i) => {
          const d = i + 1;
          const iso = `${month}-${String(d).padStart(2, "0")}`;
          const evs = byDate[iso] || [];
          const isToday = iso === today;
          return (
            <button key={d} onClick={() => nav("/calendar")} data-testid={`mini-cal-day-${d}`}
              className={`aspect-square rounded-md flex flex-col items-center justify-center text-[11px] num transition-colors hover:bg-secondary ${isToday ? "bg-primary/20 border border-primary/40 font-bold" : ""}`}>
              {d}
              <span className="flex gap-px h-1 mt-px">
                {evs.slice(0, 3).map((e, j) => (
                  <span key={j} className="w-1 h-1 rounded-full" style={{ background: COLORS[e.color] || COLORS.blue }} />
                ))}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
